import React, { useContext } from 'react';
import { LanguageContext } from '../../../Contexts/LanguageContext';
import './ServiceDetail.css';

const ServiceDetail = ({ service }) => {
    const { title, description, img, titleBangla, descriptionBangla } = service
    const [isBangla, setIsBangla] = useContext(LanguageContext)
    // console.log(title)
    return (
        <div className='col-md-4 text-center my-5'>
            <div className="card service-card m-auto" style={{ width: "19rem", border: 'none', height: '23rem' }}>
                <img src={img} className="card-img-top" alt={title} />
                {/* <FontAwesomeIcon className='m-auto' style={{ fontSize: '60px', color:'#6487FF'}} icon={icon} /> */}
                <div className="card-body">
                    <h5 className="card-title">{isBangla ? titleBangla : title}</h5>
                    <p className="card-text">{isBangla ? descriptionBangla: description}</p>
                </div>
            </div>
        </div>
    );
};

export default ServiceDetail;